import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../../config";

export const categorie = [
  "Dashboard",
  "Login",
  "Performance",
  "Preventivi",
  "Richieste",
];
export const tipo = ["Bug", "Supporto", "Nuovo requisito", "Evolutiva"];
export const stati = ["Open", "Closed", "Analysis", "In Progress", "Suspended"];
export const priorita = ["Low", "Medium", "High", "Critical"];

export const ticketService = {
  getList: async (rowsPages, pageNumbers, filters, navigate) => {
    /*     console.log(rowsPages, pageNumbers, filters); */

    try {
      //rowsPages,pageNumbers,oggetto,stato,priorita,tipo,categoria
      const token = sessionStorage.getItem("token");
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      const queryParams = new URLSearchParams();
      if (filters.oggetto) queryParams.append("oggetto", filters.oggetto);
      if (filters.priorita) queryParams.append("priorita", filters.priorita);
      if (filters.tipo) queryParams.append("tipo", filters.tipo);
      if (filters.categoria) queryParams.append("categoria", filters.categoria);
      if (filters.stato) queryParams.append("stato", filters.stato);

      const qs = queryParams.toString();

      const endpoint = `${API_BASE_URL}/api/issue/stats/${rowsPages}/${pageNumbers}${
        qs ? `?${qs}` : ""
      }`;

      const response = await fetch(endpoint, requestOptions);

      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        navigate("/private");
      }
      return responseData;

      /*  const stored = localStorage.getItem(STORAGE_KEY);
      const tickets = stored
        ? JSON.parse(stored)
        : JSON.parse(JSON.stringify(MOCK_TICKETS));

      return {
        status: 1,
        data: {
          dataset: tickets,
          totalRows: tickets.length,
          ...MOCK_CHART_DATA,
        },
      }; */
    } catch (error) {
      console.error("Error fetching tickets:", error);
      throw error;
    }
  },

  getStats: async (
    rowsPages = 5,
    pageNumbers = 1,
    filters = {},
    navigate = null,
  ) => {
    try {
      const token = sessionStorage.getItem("token");
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      const queryParams = new URLSearchParams();
      if (filters.oggetto) queryParams.append("oggetto", filters.oggetto);
      if (filters.priorita) queryParams.append("priorita", filters.priorita);
      if (filters.tipo) queryParams.append("tipo", filters.tipo);
      if (filters.categoria) queryParams.append("categoria", filters.categoria);
      if (filters.stato) queryParams.append("stato", filters.stato);

      const qs = queryParams.toString();
      const endpoint = `${API_BASE_URL}/api/issue/stats/${rowsPages}/${pageNumbers}${
        qs ? `?${qs}` : ""
      }`;

      const response = await fetch(endpoint, requestOptions);
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        if (navigate) navigate("/auth/sign-in");
      }
      if (responseData.status === 0 && navigate) {
        navigate("/private");
      }

      return responseData;
    } catch (error) {
      console.error("Error fetching ticket stats:", error);
      throw error;
    }
  },

  getFilters: async (navigate, snackbar) => {
    // For development, we return mock filters including the new Periodo filter
    const token = sessionStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
    };

    const response = await fetch(
      `${API_BASE_URL}/api/issue/filters`,
      requestOptions,
    );
    const responseData = await response.json();

    if (responseData.status === -1) {
      sessionStorage.clear();
      navigate("/auth/sign-in");
    }
    if (responseData.status === 0) {
      snackbar.showSnackbar({
        message: "Errore durante il recupero dei filtri.",
        severity: "error",
      });
    }

    // The API returns { status, message, data }
    if (responseData.status === 1) {
      return Array.isArray(responseData.data) ? responseData.data : [];
    }
    return [];
  },

  getDetails: async (idUid, navigate) => {
    try {
      const token = sessionStorage.getItem("token");

      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      const response = await fetch(
        `${API_BASE_URL}/api/issue/${idUid}`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }
      return responseData;
    } catch (error) {
      console.error("Error fetching ticket details:", error);
      throw error;
    }
  },

  handleAddTicket: async (ticket, navigate) => {
    try {
      const token = sessionStorage.getItem("token");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          ...ticket,
        }),
      };

      const response = await fetch(`${API_BASE_URL}/api/issue`, requestOptions);
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      console.error("Error saving ticket:", error);
      throw error;
    }
  },

  handleUpdateTicket: async (ticket) => {
    const newJSON = {
      idCategoria: ticket.idCategoria,
      idPriorita: ticket.idPriorita,
      idStato: ticket.idStato,
      idTipo: ticket.idTipo,
      idUID: ticket.idUID,
      closeNote: ticket.closeNote,
    };

    console.log(newJSON);
    try {
      const token = sessionStorage.getItem("token");
      const requestOptions = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          data: newJSON,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/issue/${newJSON.idUID}`,
        requestOptions,
      );
      const responseData = await response.json();

      return responseData;
    } catch (error) {
      console.error("Error saving ticket:", error);
      throw error;
    }
  },

  handleSendMessage: async (ticketId, message, navigate) => {
    try {
      const token = sessionStorage.getItem("token");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          ticketId,
          message,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/issueSendMessage`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      if (responseData.status === 1) {
        return responseData.data;
      }
      return responseData;
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  },
};
